import styled from '@xstyled/styled-components';
import React, { ReactNode } from 'react';

const Line = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-top: 12px;
`;

const Label = styled.span`
  flex: none;
  font-size: 13px;
  font-weight: 600;
  color: var(--color-grey-dk);
`;

const LABEL = 'Name for [user]';

/** Whether a child of an email is its name line (see EmailHelper). */
export const isUserNameLine = (child: ReactNode, emailId: string) =>
  React.isValidElement<{ id?: string }>(child) &&
  child.props.id === `${emailId}_title`;

/**
 * The editor's line for the name an email's [user] token stands for. Learners
 * never see it: they read the name in the body instead.
 */
export const UserNameLine = ({ children }: { children: ReactNode }) => (
  <Line role="group" aria-label={LABEL}>
    <Label aria-hidden="true">{LABEL}</Label>
    {children}
  </Line>
);
